/** Operator-facing copy for legacy customer link (admin Identity tab). */

export const LEGACY_LINKAGE_PANEL = {
  title: 'Legacy customer link',
  subtitle: 'Link this application to a Cash4You customer record before funding.',
  reviewSectionTitle: 'Review candidates',
  refresh: 'Refresh',
  confirmLink: (legacyCustomerId: string) => `Confirm link to ${legacyCustomerId}`,
  notThisPerson: 'Create new customer ID',
  noneOfTheseMint: 'Create new customer ID',
  assignNewId: 'Create new customer ID',
  retryResolve: 'Retry automatic link',
  technicalDetails: 'System details',
  helpToggleShow: 'How does linking work?',
  helpToggleHide: 'Hide help',
  helpBody:
    'After identity verification, we match the selfie to legacy Cash4You records. Auto-link requires a close face match plus matching first name and date of birth. When details conflict, confirm the correct legacy customer or create a new ID.',
  columnApplicant: 'This application (IV)',
  columnLegacy: 'Legacy (Cash4You)',
  legacyCustomerIdLabel: 'Legacy customer ID',
  bindConfirm: (legacyCustomerId: string) =>
    `Confirm link to legacy customer ${legacyCustomerId}? This cannot be undone.`,
  mintConfirm:
    'Create a new customer ID for this applicant? Use when no legacy record matches this person.',
  bindSuccess: (legacyCustomerId: string) => `Linked to legacy customer ${legacyCustomerId}.`,
  mintSuccess: 'Assigned a new customer ID.',
} as const;

export function formatIdentityDriftHeadline(
  reviewLine: string,
  identityLine: string,
): string {
  return `Resolve used ${reviewLine}; identity now shows ${identityLine} — confirm which is correct before linking.`;
}

export function formatDecisionEngineMismatchCopy(
  decisionEngineId: string,
  linkedId: string,
): string {
  return `Decision engine customer ID (${decisionEngineId}) differs from linked legacy ID (${linkedId}). Review on the Identity tab.`;
}
